import { authRoles } from 'app/auth';
import { lazy } from 'react';

const DataAppConfig = {
	settings: {
		layout: {}
	},
	auth: [...authRoles.admin, ...authRoles.productModerator],
	routes: [
		{
			path: '/apps/products/search',
			exact: true,
			component: lazy(() => import('./search/Datas'))
		},
		{
			path: '/apps/products/create-edit',
			exact: true,
			component: lazy(() => import('./update/Data'))
		},
		{
			path: '/apps/products/excel/update',
			exact: true,
			component: lazy(() => import('./excel/Data'))
		},
		{
			path: '/apps/products/change-product-price',
			exact: true,
			component: lazy(() => import('./changeProductPrice/Data'))
		},
		{
			path: '/apps/products/change-product-price/:groupId',
			exact: true,
			component: lazy(() => import('./changeProductPrice/PriceHistoryTab/single'))
		},
		{
			path: '/apps/report/change-dept',
			exact: true,
			component: lazy(() => import('./change-dept/Data'))
		},
		{
			path: '/apps/report/change-dept/:groupId',
			exact: true,
			component: lazy(() => import('./change-dept/single/Data'))
		},
		{
			path: '/apps/products',
			exact: true,
			component: lazy(() => import('./list/Datas'))
		},
		{
			path: '/apps/products/characteristics',
			exact: true,
			component: lazy(() => import('./characteristics/Datas'))
		},
		{
			path: '/apps/products/characteristics/:characteristicId',
			exact: true,
			component: lazy(() => import('./addEditProductCharacteristic/Data'))
		}
	]
};

export default DataAppConfig;
